var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      !_vm.isMobile
        ? _c("router-view", { attrs: { name: "pcheader" } })
        : _c("router-view", {
            attrs: {
              name: "spheader",
              "back-handler": _vm.backHandler,
              "action-handler": _vm.actionHandler,
              enableButton: _vm.enableButton,
              buttonName: _vm.buttonName
            }
          }),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _vm.alert.message
          ? _c("div", { class: "alert " + _vm.alert.type }, [
              _vm._v(_vm._s(_vm.alert.message))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-cnt" },
          [
            _c("router-view", { attrs: { name: "sidebar" } }),
            _vm._v(" "),
            !_vm.isMobile
              ? _c("router-view", { attrs: { name: "pcbody" } })
              : _c("router-view", {
                  attrs: { name: "spbody" },
                  on: {
                    "update:backHandler": function($event) {
                      _vm.backHandler = $event
                    },
                    "update:actionHandler": function($event) {
                      _vm.actionHandler = $event
                    },
                    enableButton: _vm.setButton
                  }
                })
          ],
          1
        )
      ]),
      _vm._v(" "),
      !_vm.isMobile
        ? _c("router-view", { attrs: { name: "pcfooter" } })
        : _c("router-view", { attrs: { name: "spfooter" } }),
      _vm._v(" "),
      _vm.isLoading ? _c("loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 